/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Doc_Type_Boundary_PlanInputs */

const en_doc_type_boundary_plan = /** @type {(inputs: Doc_Type_Boundary_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boundary Plan`)
};

const id_doc_type_boundary_plan = /** @type {(inputs: Doc_Type_Boundary_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rencana Batas`)
};

/** @type {(inputs: Doc_Type_Boundary_PlanInputs) => LocalizedString} */
const es_doc_type_boundary_plan = en_doc_type_boundary_plan;

/** @type {(inputs: Doc_Type_Boundary_PlanInputs) => LocalizedString} */
const fr_doc_type_boundary_plan = en_doc_type_boundary_plan;

/** @type {(inputs: Doc_Type_Boundary_PlanInputs) => LocalizedString} */
const de_doc_type_boundary_plan = en_doc_type_boundary_plan;

/** @type {(inputs: Doc_Type_Boundary_PlanInputs) => LocalizedString} */
const ja_doc_type_boundary_plan = en_doc_type_boundary_plan;

/** @type {(inputs: Doc_Type_Boundary_PlanInputs) => LocalizedString} */
const zh_doc_type_boundary_plan = en_doc_type_boundary_plan;

/** @type {(inputs: Doc_Type_Boundary_PlanInputs) => LocalizedString} */
const ar_doc_type_boundary_plan = en_doc_type_boundary_plan;

/** @type {(inputs: Doc_Type_Boundary_PlanInputs) => LocalizedString} */
const it_doc_type_boundary_plan = en_doc_type_boundary_plan;

/** @type {(inputs: Doc_Type_Boundary_PlanInputs) => LocalizedString} */
const ru_doc_type_boundary_plan = en_doc_type_boundary_plan;

/** @type {(inputs: Doc_Type_Boundary_PlanInputs) => LocalizedString} */
const pt_doc_type_boundary_plan = en_doc_type_boundary_plan;

/** @type {(inputs: Doc_Type_Boundary_PlanInputs) => LocalizedString} */
const ko_doc_type_boundary_plan = en_doc_type_boundary_plan;

/**
* | output |
* | --- |
* | "Boundary Plan" |
*
* @param {Doc_Type_Boundary_PlanInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const doc_type_boundary_plan = /** @type {((inputs?: Doc_Type_Boundary_PlanInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Doc_Type_Boundary_PlanInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_doc_type_boundary_plan(inputs)
	if (locale === "es") return es_doc_type_boundary_plan(inputs)
	if (locale === "fr") return fr_doc_type_boundary_plan(inputs)
	if (locale === "de") return de_doc_type_boundary_plan(inputs)
	if (locale === "ja") return ja_doc_type_boundary_plan(inputs)
	if (locale === "zh") return zh_doc_type_boundary_plan(inputs)
	if (locale === "ar") return ar_doc_type_boundary_plan(inputs)
	if (locale === "id") return id_doc_type_boundary_plan(inputs)
	if (locale === "it") return it_doc_type_boundary_plan(inputs)
	if (locale === "ru") return ru_doc_type_boundary_plan(inputs)
	if (locale === "pt") return pt_doc_type_boundary_plan(inputs)
	return ko_doc_type_boundary_plan(inputs)
});